<template>
  <div class="ques-des" v-if="descriptionText">
    {{ descriptionText }}
  </div>
</template>

<script>
export default {
  props: {
    currItem: {
      type: Object,
      default: () => {},
    },
    code: {
      type: String,
      default: '',
    },
  },
  computed: {
    language() {
      let local = localStorage.getItem('language')
      if (local == 'zh') {
        return 'cn'
      } else {
        return local
      }
    },
    descriptionText() {
      return this.currItem.question_description_obj
        ? this.currItem.question_description_obj[this.language]
          ? this.currItem.question_description_obj[this.language]
          : this.currItem.question_description_obj['zh']
          ? this.currItem.question_description_obj['zh']
          : ''
        : ''
    },
  },
}
</script>

<style lang="scss" scoped>
.ques-des {
  position: absolute;
  left: 29px;
  top: 20px;
  font-size: 12px;
  font-weight: 400;
  color: #b5b5be;
  margin-top: 0px;
}
</style>
